window.__assetPrefix__ = 'https://d3ofgp0xi3yy64.cloudfront.net/frontend-payroll';